"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LocationsV = _interopRequireDefault(require("./LocationsV2.variants"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LocationsV2 = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LocationsV2, _React$Component);

  var _super = _createSuper(LocationsV2);

  function LocationsV2() {
    (0, _classCallCheck2["default"])(this, LocationsV2);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(LocationsV2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variation = _this$props.variation,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["variation", "className"]);
      var Body = _LocationsV["default"][variation];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "fc-locations ".concat(className)
      }, /*#__PURE__*/_react["default"].createElement(Body, rest));
    }
  }]);
  return LocationsV2;
}(_react["default"].Component);

exports["default"] = LocationsV2;
LocationsV2.propTypes = {
  variation: _propTypes["default"].oneOf(['LocationsV2TopMap', 'LocationsV2Simple', 'LocationsV2SingleLocation']),
  locations: _propTypes["default"].shape({
    address: _propTypes["default"].object,
    phoneNumber: _propTypes["default"].string,
    email: _propTypes["default"].string,
    hours: _propTypes["default"].object
  }),
  verticalAlign: _propTypes["default"].string,
  horizonalAlign: _propTypes["default"].string
};
LocationsV2.defaultProps = {
  variation: 'LocationsV2TopMap',
  locations: [],
  verticalAlign: 'center'
};